import {Button, Tooltip} from 'antd';
import {useDispatch} from 'umi';
import React from 'react';
import {EditOutlined} from '@ant-design/icons';
import {F} from '@/utils/intl';


const EditCalendarEventAction = ({
                                   children = null,
                                   calendarEvent,
                                   lead,
                                   setLoading = (loading: boolean) => {
                                   },
                                   onOpenEdit,
                                   onSuccess = () => {
                                   },
                                   buttonSize = 'small',
                                   showActionText = false,
                                   ...buttonProps
                                 }) => {

  const dispatch = useDispatch()
  const handleEditCalendarEvent = () => {
    if (onOpenEdit) onOpenEdit();
    dispatch({
      type: 'serviceRequest/toggleCreateServiceRequestDrawer',
      payload: {
        open: true,
        event: {
          ...calendarEvent,
          lead,
          blocker: true,
        },
        then: onSuccess,
      },
    });
  };

  return <Tooltip title={showActionText ? undefined : <F id={'common.actions.edit'} defaultMessage={'Edit'}/>}>
    <Button
      size={buttonSize}
      icon={<EditOutlined />}
      variant={"filled"}
      color={"default"}
      shape={"round"}
      onClick={() => handleEditCalendarEvent()}
      {...buttonProps}
    >
      {showActionText && <F id={'common.actions.edit'} defaultMessage={'Edit'}/>}
    </Button>
  </Tooltip>
}

export default EditCalendarEventAction
